export default __webpack_public_path__ + "static/media/logo.6db2ac42.png";